import React, { useState, useContext } from "react";
import moment from 'moment'
import Utilities from "../../../../../services/commonservice/utilities";
import { store } from "../../../../../context/StateProvider";
import Module from "../../../../templates/components/Module";
import Table2 from "../../../../templates/components/Table2";
import DatePicker from "../../../../templates/components/DatePicker";
import HPTSelect from "../../../../templates/components/HPTSelect";
import ReportService from "../../../../../services/api/report.service";

const LifeTimeValue = (props) => {
    const [lifeTimeValueData, setLifeTimeValueData] = useState();
    const [isLoader, setIsLoader] = useState(false)
    const [startDate, setStartDate] = useState(moment().startOf("D"));
    const [endDate, setEndDate] = useState(moment().endOf("D"));
    const state = useContext(store).state
    const [initialMessage, setInitialMessage] = useState(true)
    const [locationId, setLocationId] = useState(state.practiceLocationId || null)
    const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)

    const [reportGroup, setReportGroup] = useState()

    const reportGroupList = [
        { key: "Product", value: "Product" },
        { key: "Service", value: "Service" },
        { key: "Canceled", value: "Canceled" },
        { key: "Prepaid Credit", value: "Prepaid Credit" },
        { key: "Unsubscribed", value: "Unsubscribed" },
        { key: "Fee", value: "Fee" },
        { key: "Membership", value: "Membership" },
        { key: "Membership Item Redeemed", value: "MembershipItemRedeemed" }
    ];
    const getLifeTimeValue = () => {
        setInitialMessage(false);
        setIsLoader(true)
        var reqObj = {}
        if (startDate) reqObj.StartDate = moment(startDate).format("YYYY-MM-DD")
        if (endDate) reqObj.EndDate = moment(endDate).format("YYYY-MM-DD")
        if (reportGroup && reportGroup.length > 0) reqObj.ReportGroup = reportGroup
        if (locationId) reqObj.PracticeLocationIds = locationId
        ReportService.getPatientsLifeTimeValueReport(reqObj).then(response => {
            //console.log(response)
            setLifeTimeValueData(response?.data);
            setIsLoader(false)
        }).catch((err) => console.log(err));
    }

    const columns = [
        {
            id: "firstName",
            Header: "First Name",
            accessor: patient => patient.firstName || ""
        },
        {
            id: "lastName",
            Header: "Last Name",
            accessor: patient => patient.lastName || ""
        },
        {
            id: "practiceLocation",
            Header: "Practice Location",
            accessor: patient => patient.practiceLocation || ""
        },
        {
            id: "dob",
            Header: "DOB",
            accessor: patient => patient.dob ? moment.utc(patient.dob).format("MM/DD/YYYY") : ""
        },
        {
            id: "addressLine1",
            Header: "Address",
            accessor: patient => patient.addressLine1 || ""
        },
        {
            id: "city",
            Header: "City",
            accessor: patient => patient.city || ""
        },
        {
            id: "state",
            Header: "State",
            accessor: patient => patient.state || ""
        },
        {
            id: "postalCode",
            Header: "Postal Code",
            accessor: patient => patient.postalCode || "",
            //Footer: () => { return 'Totals' }
        },
        // {
        //     id: "invoiceDate",
        //     Header: "Invoice Date",
        //     accessor: patient => patient.invoiceDate ? moment.utc(patient.invoiceDate).format("MM/DD/YYYY") : ""
        // },
        {
            id: "reportGroup",
            Header: "Report Group",
            accessor: patient => patient.reportGroup
        },
        {
            id: "total",
            Header: "Total",
            accessor: (patient) => Utilities.toDollar(patient.total),
            Footer: info => {
                const total = React.useMemo(
                    () =>
                        info.rows.reduce((sum, row) => row.original.total + sum, 0),
                    [info.rows]
                )

                return <>{Utilities.toDollar(total)}</>
            },
        },
    ]

    return (
        <>
            <div className="row d-flex g-3">
                <div className='col-12 m-p-0'>
                    <Module title="Filters">
                        <div className='row d-flex'>
                            <div className='col-12 row d-flex justify-content-center mx-0 align-items-end report-filters'>
                                <DatePicker includeAll locationClearable={isLocationClearable} setLocationId={setLocationId} startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} />
                                <div className='col-md-auto col-12' style={{ minWidth: '200px' }}>
                                    <div className='ui field'>
                                        <label>Report Group</label>
                                        <HPTSelect
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            placeholder="All"
                                            options={reportGroupList}
                                            onChange={(selectedOptions) => {
                                                const values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                                                setReportGroup(values);
                                            }}
                                            isMulti
                                            isSearchable
                                            isClearable
                                            getOptionLabel={(option) => option.key}
                                            getOptionValue={(option) => option.value}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-auto col-12"><button className="btn btn-primary" onClick={e => { e.preventDefault(); setLifeTimeValueData(); getLifeTimeValue() }} title="Pull Report"><i className="icon arrow circle right" /></button></div>
                            </div>
                        </div>
                    </Module>
                </div>
                <div className="col-12 m-p-0">
                    <Module title="Life Time Value Report">
                        <Table2
                            export
                            searchable
                            data={lifeTimeValueData}
                            columns={columns}
                            loading={isLoader}
                            title='Life Time Value Report'
                            initialMessage={initialMessage}
                        />
                    </Module>
                </div>
            </div>
        </>
    )
}

export default LifeTimeValue;